import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.course.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_COURSE_ASYNC: `${uid}.saveCourseAsync`,
    SAVE_COURSE_SUCCESS: `${uid}.saveCourseSuccess`,
    SAVE_COURSE_FAILURE: `${uid}.saveCourseFailure`,
    CREATE_COURSE: `${uid}.createCourse`
};

export { ActionTypes };
